<template>
  <main class="container solution-fly">
    <section ref="sectionRef" class="wellcome-section">
      <button class="btn outline">
        Flying Insect Control Solution <br class="mo_show" />
        (FIC Solution)
      </button>
      <h1>
        CESCO's Unique Approach to <br />
        Blocking Flying Insects
      </h1>
      <p>
        Flying pests that invade 24 hours a day, year-round, are blocked step-by-step with CESCO's advanced devices. We monitor and analyze the
        sources of infestations to provide a complete solution.
      </p>

      <router-link to="/contact/mail/send?local=eng">
        <p ref="buttonRef" id="applyButton" :class="[buttonClass, buttonHiddenClass]">Send Email</p>
      </router-link>
    </section>

    <img
      :src="require(`@/assets/images/solution/fly/main${mobileCheck ? '_mo' : ''}.png`)"
      class="main-img"
      alt="CESCO [Solution] Flying Insect Control Solution (FIC Solution)"
    />

    <section class="navi-mo-swiper fly-entrance">
      <div>
        <div>
          <h3 class="title-section">Flying insects can easily appear anywhere.</h3>

          <p class="description-section">
            Flying insects are insects that fly from outside into indoor spaces, <br class="pc_show" />
            including flies, moths, midges, mosquitoes, drain flies, and mayflies.
          </p>
        </div>

        <span class="swiper-navigation">
          <button type="button" :disabled="entrancePrevDisabled" @click="entranceSlidePrev">
            <img src="@/assets/images/icons/Left Circle.svg" />
          </button>
          <button type="button" :disabled="entranceNextDisabled" @click="entranceSlideNext">
            <img src="@/assets/images/icons/Right Circle.svg" />
          </button>
        </span>
      </div>

      <swiper ref="entranceSwiperRef" :slides-per-view="'auto'" @slideChange="onEntranceSlideChange" class="fly-entrance-swiper">
        <swiper-slide>
          <div class="card-entrance">
            <img src="@/assets/images/solution/fly/card_entrance_01.png" alt="CESCO [Solution] Flying Insect Control Solution (FIC Solution)" />
            <p>
              <span> Entrance Doors </span>
            </p>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="card-entrance">
            <img src="@/assets/images/solution/fly/card_entrance_02.png" alt="CESCO [Solution] Flying Insect Control Solution (FIC Solution)" />
            <p>
              <span> Food Waste, Drains, Trenches </span>
            </p>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="card-entrance">
            <img src="@/assets/images/solution/fly/card_entrance_03.png" alt="CESCO [Solution] Flying Insect Control Solution (FIC Solution)" />
            <p>
              <span> Windows and Gaps </span>
            </p>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="card-entrance">
            <img src="@/assets/images/solution/fly/card_entrance_04.png" alt="CESCO [Solution] Flying Insect Control Solution (FIC Solution)" />
            <p>
              <span> Outdoor Garbage Areas </span>
            </p>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="card-entrance">
            <img src="@/assets/images/solution/fly/card_entrance_05.png" alt="CESCO [Solution] Flying Insect Control Solution (FIC Solution)" />
            <p>
              <span> Food Storage Areas </span>
            </p>
          </div>
        </swiper-slide>
      </swiper>
    </section>

    <section class="section fly-cause">
      <div class="contents-center">
        <h3 class="title-section center">
          Flying insects can cause serious problems<br />
          for businesses.
        </h3>
        <p class="description-section center">
          Even one small flying insects entering food or products can damage<br class="pc_show" />
          a company's brand image and lead to significant business losses.
        </p>

        <div class="card-type-h">
          <div>
            <div class="card" @click="handlePestsClick(0)">
              <img src="@/assets/images/solution/fly/card_h_01.png" alt="CESCO [Solution] Flying Insect Control Solution (FIC Solution)" />
              <div class="hover-box">
                <div class="text-box">
                  <p>High reproductive <br />rate</p>
                  <h4>Flies</h4>
                  <span class="hover-show">
                    Some may think that having just one or two flies is not a serious issue. However, flies can lay 100-150 eggs at a time and may do
                    so up to 20 times throughout their life.
                  </span>
                </div>
                <button type="button" class="plus">
                  <img src="@/assets/images/icons/plus-round.svg" />
                </button>
              </div>
            </div>
            <div class="card" @click="handlePestsClick(1)">
              <img src="@/assets/images/solution/fly/card_h_02.png" alt="CESCO [Solution] Flying Insect Control Solution (FIC Solution)" />
              <div class="hover-box">
                <div class="text-box">
                  <p>Swarm formations around bright lights</p>
                  <h4>Midges</h4>
                  <span class="hover-show">
                    Midges are particularly attracted to bright lights, are larger than mosquitoes, and can cause discomfort. When they fly around
                    inside and outside a store, they can harm the store's image.
                  </span>
                </div>
                <button type="button" class="plus">
                  <img src="@/assets/images/icons/plus-round.svg" />
                </button>
              </div>
            </div>
            <div class="card" @click="handlePestsClick(2)">
              <img src="@/assets/images/solution/fly/card_h_03.png" alt="CESCO [Solution] Flying Insect Control Solution (FIC Solution)" />
              <div class="hover-box blur">
                <div class="text-box">
                  <p>Camouflage as coarse black pepper in food</p>
                  <h4>Fruit flies</h4>
                  <span class="hover-show">
                    They are commonly found around sinks, fruit, and food waste. Without proper management, they gather in dirty drains and on spoiled
                    food, laying eggs and multiplying quickly.
                  </span>
                </div>
                <button type="button" class="plus">
                  <img src="@/assets/images/icons/plus-round.svg" />
                </button>
              </div>
            </div>
          </div>
          <div>
            <div class="card" @click="handlePestsClick(3)">
              <img src="@/assets/images/solution/fly/card_h_04.png" alt="CESCO [Solution] Flying Insect Control Solution (FIC Solution)" />
              <div class="hover-box blur">
                <div class="text-box">
                  <p>Wings cause issues after death</p>
                  <h4>Moths</h4>
                  <span class="hover-show">
                    While moths do not suck blood like mosquitoes or spread diseases, they can still pose a risk. If moth carcass fragments mix with
                    the air and are inhaled, they can cause respiratory problems.
                  </span>
                </div>
                <button type="button" class="plus">
                  <img src="@/assets/images/icons/plus-round.svg" />
                </button>
              </div>
            </div>
            <div class="card" @click="handlePestsClick(4)">
              <img
                class="i-11"
                src="@/assets/images/solution/fly/card_h_05.png"
                alt="CESCO [Solution] Flying Insect Control Solution (FIC Solution)"
              />
              <div class="hover-box blur">
                <div class="text-box">
                  <p>Can easily penetrate rice bags</p>
                  <h4>Indianmeal moths</h4>
                  <span class="hover-show">
                    These pests mainly appear in areas where food dust or grains are stored. Their larvae have strong jaws that can even chew through
                    rice bags.
                  </span>
                </div>
                <button type="button" class="plus">
                  <img src="@/assets/images/icons/plus-round.svg" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="navi-swiper fly-solution">
      <div>
        <h3>CESCO's flying insects solution is unmatched<br />in technology, making it the No. 1 solution.</h3>

        <span class="swiper-navigation">
          <button type="button" :disabled="prevDisabled" @click="slidePrev">
            <img src="@/assets/images/icons/Left Circle.svg" />
          </button>
          <button type="button" :disabled="nextDisabled" @click="slideNext">
            <img src="@/assets/images/icons/Right Circle.svg" />
          </button>
        </span>
      </div>

      <swiper ref="swiperRef" :slides-per-view="'auto'" :centered-slides="true" @slideChange="onSlideChange" class="fly-solution-swiper">
        <swiper-slide>
          <div class="solution-slide">
            <h6>Hyper-Control LED Trap™</h6>
            <img :src="require(`@/assets/images/solution/fly/chart_01${mobileCheck ? '_mo' : ''}.svg`)" alt="chart_1" />
          </div>
        </swiper-slide>

        <swiper-slide>
          <div class="solution-slide">
            <h6>Exclusive capture cartridges using CESCO's specialized technology</h6>
            <img :src="require(`@/assets/images/solution/fly/chart_02${mobileCheck ? '_mo' : ''}.svg`)" alt="chart_2" />
          </div>
        </swiper-slide>

        <swiper-slide>
          <div class="solution-slide">
            <h6>Eco-Friendly Energy Efficiency</h6>
            <img :src="require(`@/assets/images/solution/fly/chart_03${mobileCheck ? '_mo' : ''}.svg`)" alt="chart_3" />
          </div>
        </swiper-slide>

        <swiper-slide>
          <div class="solution-slide">
            <h6>IoT system for receiving and analyzing real-time data</h6>
            <img :src="require(`@/assets/images/solution/fly/chart_04${mobileCheck ? '_mo' : ''}.svg`)" alt="chart_4" />
          </div>
        </swiper-slide>
      </swiper>
    </section>

    <section class="section tab-area">
      <div class="contents-center">
        <div class="tab-info">
          <h3 class="title-section">CESCO's 4-Step Defense Line System for Flying Insects</h3>
          <p class="description-section center">
            From outermost perimeter defense to self-care, we offer a complete solution rather than
            <br />
            just simple capture. A variety of products are available to provide the
            <br />
            best solution tailored to each business.
          </p>
        </div>

        <div class="tabs">
          <button
            v-for="item in tabList"
            :key="`tab-${item.id}`"
            :id="`tab-${item.id}`"
            :class="['tab-button', tab === item.id && 'active']"
            @click="handleTabClick(item.id)"
          >
            {{ item.name }}
          </button>
        </div>
        <button class="btn-list">Press the button to check.</button>
      </div>

      <div v-if="!mobileCheck" class="tab-contents">
        <div v-if="tab === 0" class="tab-content" id="tab1">
          <div class="swiper-n">
            <div class="card">
              <h5>The Best Capture Rate in the Country</h5>
              <h4>Thunderblue</h4>
              <img src="@/assets/images/solution/fly/tab01_01.png" alt="CESCO [Solution] Flying Insect Control Solution (FIC Solution)" />
              <p>
                Equipped with the highest number of lamps (4) in the country, featuring automatic counting and analysis to provide a customized pest
                control program
              </p>
            </div>
          </div>
        </div>

        <div v-if="tab === 1" class="tab-content" id="tab2">
          <div class="swiper-n">
            <div>
              <div class="card">
                <h5>Secondary Defense at the Building and Entrance Boundaries</h5>
                <h4>Bluestorm</h4>
                <img src="@/assets/images/solution/fly/tab02_01.png" alt="CESCO [Solution] Flying Insect Control Solution (FIC Solution)" />
                <p>Lamps with strong light attraction and long-lasting performance</p>
              </div>
            </div>

            <div>
              <div class="card">
                <h5>Complete Blockage of Entry via Entrance Doors</h5>
                <h4>Air Curtain</h4>
                <img src="@/assets/images/solution/fly/tab02_02.png" alt="CESCO [Solution] Flying Insect Control Solution (FIC Solution)" />
                <p>Effectively blocks flying pests and outside air while managing heating and cooling efficiently</p>
              </div>
            </div>
          </div>
        </div>

        <div v-if="tab === 2" class="tab-content" id="tab3">
          <div class="swiper-n">
            <div>
              <div class="card">
                <h5>Low-Power, High-Efficiency, High-Performance Capture</h5>
                <h4>Phoenix Pro</h4>
                <img src="@/assets/images/solution/fly/tab03_01.png" alt="CESCO [Solution] Flying Insect Control Solution (FIC Solution)" />
                <p>Achieves 130% capture rate with LED trap modules and offers tailored solutions for businesses through an IoT system</p>
              </div>
            </div>

            <div>
              <div class="card">
                <h5>Not Restricted by Installation Conditions</h5>
                <h4>BlueON Slim</h4>
                <img src="@/assets/images/solution/fly/tab03_02.png" alt="CESCO [Solution] Flying Insect Control Solution (FIC Solution)" />
                <p>
                  Compact size with various installation options<br />
                  Delivers a 130% capture rate compared to existing models
                </p>
              </div>
            </div>

            <div>
              <div class="card">
                <h5>
                  Enhances Interior
                  <br />
                  Appearance
                </h5>
                <h4>BlueON Art</h4>
                <img src="@/assets/images/solution/fly/tab03_03.png" alt="CESCO [Solution] Flying Insect Control Solution (FIC Solution)" />
                <p>A stylish design combined with the powerful capture ability of LED trap modules</p>
              </div>
            </div>
          </div>
        </div>

        <div v-if="tab === 3" class="tab-content" id="tab4">
          <swiper :slides-per-view="'auto'" :spaceBetween="20" class="fly-maylab-swiper">
            <swiper-slide class="card">
              <h4 class="single">
                CESCO Mylab<br />
                Fly Stick
              </h4>
              <img src="@/assets/images/solution/fly/tab04_01.png" alt="CESCO [Solution] Flying Insect Control Solution (FIC Solution)" />
              <p>Strongly attracts flies and fruit flies with specially designed 3D patterns and colors</p>
            </swiper-slide>
            <swiper-slide class="card">
              <h4 class="single">
                Fruit Fly<br />
                Attractant
              </h4>
              <img src="@/assets/images/solution/fly/tab04_02.png" alt="CESCO [Solution] Flying Insect Control Solution (FIC Solution)" />
              <p>Effectively attracts fruit flies using concentrated food fermentation extracts</p>
            </swiper-slide>
            <swiper-slide class="card">
              <h4 class="single">
                CESCO Mylab<br />
                Multi-Moth Trap
              </h4>
              <img src="@/assets/images/solution/fly/tab04_03.png" alt="CESCO [Solution] Flying Insect Control Solution (FIC Solution)" />
              <p>Uses pheromones to attract and capture stored product moths</p>
            </swiper-slide>
            <swiper-slide class="card">
              <h4 class="single">
                CEScare<br />
                Drain Cleaner
              </h4>
              <img src="@/assets/images/solution/fly/tab04_04.png" alt="CESCO [Solution] Flying Insect Control Solution (FIC Solution)" />
              <p>Effectively sterilizes harmful bacteria and organic matter in drains</p>
            </swiper-slide>
            <swiper-slide class="card">
              <h4 class="single">
                CESCO Mylab Mosquito Aerosol/
                <br />
                Mosquito Repellent
              </h4>
              <img src="@/assets/images/solution/fly/tab04_05.png" alt="CESCO [Solution] Flying Insect Control Solution (FIC Solution)" />
              <p>Contains ingredients safe for use in lotions, suitable for infants and pregnant women!</p>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </section>

    <section class="section fly-works">
      <div class="contents-center">
        <div class="works-title">
          <h3 class="title-section">
            How does it <br class="pc_show" />
            work?
          </h3>
          <p class="description-section">
            Flying insects are constantly appearing and entering, requiring regular management through integrated control. CESCO’s flying pest expert
            consultants provide <br class="pc_show" />
            customized solutions through on-site visits.
          </p>
        </div>
        <div class="works-card">
          <div class="card">
            <img
              :src="require(`@/assets/images/solution/fly/how_does_01${mobileCheck ? '_mo' : ''}.png`)"
              alt="CESCO [Solution] Flying Insect Control Solution (FIC Solution)"
            />
            <div class="text-box">
              <h4>01</h4>
              <p>
                Preliminary Inspection <br />
                and Diagnosis
              </p>
              <span> A professional consultant visits for diagnosis and removal of detected flying pests </span>
            </div>
          </div>

          <div class="card">
            <img
              :src="require(`@/assets/images/solution/fly/how_does_02${mobileCheck ? '_mo' : ''}.png`)"
              alt="CESCO [Solution] Flying Insect Control Solution (FIC Solution)"
            />
            <div class="text-box">
              <h4>02</h4>
              <p>
                Customized<br class="pc_show" />
                Plan
              </p>
              <span class="fs-24"> 4-Step Defense Line System tailored to the store's size and specific needs </span>
            </div>
          </div>

          <div class="card">
            <img
              :src="require(`@/assets/images/solution/fly/how_does_03${mobileCheck ? '_mo' : ''}.png`)"
              alt="CESCO [Solution] Flying Insect Control Solution (FIC Solution)"
            />
            <div class="text-box">
              <h4>03</h4>
              <p>
                Installation of CESCO <br class="mo_show" />
                Equipment
              </p>
              <span> Install and monitor equipment according to a customized plan </span>
            </div>
          </div>

          <div class="card">
            <img
              :src="require(`@/assets/images/solution/fly/how_does_04${mobileCheck ? '_mo' : ''}.png`)"
              alt="CESCO [Solution] Flying Insect Control Solution (FIC Solution)"
            />
            <div class="text-box">
              <h4>04</h4>
              <p>Regular Maintenance <br />Service</p>
              <span class="fs-24">
                Additional consulting based on the types and quantities of pests captured, with regular replacement of cartridges and lamps
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section cesco-mark-section">
      <div class="contents-center">
        <div class="cesco-card">
          <div class="header">
            <h4 class="title">Hygiene planning for businesses should begin at the interior design stage.</h4>
            <p class="description">Planning for hygiene from the interior design stage helps minimize unnecessary aftercare costs and time waste.</p>
          </div>

          <swiper
            :slides-per-view="'auto'"
            :loop="true"
            :autoplay="{
              delay: 2000,
              disableOnInteraction: false
            }"
            :spaceBetween="8"
            :breakpoints="{
              768: {
                spaceBetween: 20
              }
            }"
            :modules="[Autoplay]"
            class="cesco-swiper"
          >
            <swiper-slide class="cesco-slide-item">
              <img src="@/assets/images/solution/fly/cesco_swiper_01.png" alt="CESCO [Solution] Flying Insect Control Solution (FIC Solution)" />
              <p>
                <span>
                  Before Interior <br />
                  Construction
                </span>
                Hygiene <br />
                Diagnosis
              </p>
            </swiper-slide>
            <swiper-slide class="cesco-slide-item">
              <img src="@/assets/images/solution/fly/cesco_swiper_02.png" alt="CESCO [Solution] Flying Insect Control Solution (FIC Solution)" />

              <p>
                <span>
                  During Interior <br />
                  Construction
                </span>
                Solution Design
              </p>
            </swiper-slide>
            <swiper-slide class="cesco-slide-item">
              <img src="@/assets/images/solution/fly/cesco_swiper_03.png" alt="CESCO [Solution] Flying Insect Control Solution (FIC Solution)" />
              <p>
                <span> After Interior Construction </span>
                Members Mark & <br />
                Routine <br />
                Maintenance
              </p>
            </swiper-slide>
          </swiper>
        </div>

        <div class="cesco-card">
          <div class="header">
            <h4 class="title">
              The CESCO <br />
              Members' Mark
            </h4>
            <p class="description">
              For businesses, we offer a <br class="mo_show" />
              certification mark to help customers recognize the space as safe and hygienic.
            </p>
          </div>
          <div class="card-image">
            <img
              :src="require(`@/assets/images/solution/cesco_members${mobileCheck ? '_mo' : ''}.png`)"
              alt="CESCO [Solution] Flying Insect Control Solution (FIC Solution)"
            />
          </div>
        </div>
      </div>
    </section>

    <section ref="checkSectionRef" class="sub-footer">
      <h2>
        CESCO’s Unmatched Technology,
        <br />
        Flying insects Solution
      </h2>

      <p>
        We analyze the source of infestations to provide a complete solution,<br />
        not just a simple capture.
      </p>

      <router-link to="/contact/mail/send?local=eng" class="btn"> Send Email </router-link>
    </section>
  </main>

  <ModalView v-if="mobileCheck" :modal-state="modalState" @close-modal="closeModal">
    <FlyModalContent :tab="tab" :text="tabList[tab].name" />
  </ModalView>

  <ModalView v-if="mobileCheck" type="card" :modal-state="pestsModalState" @close-modal="closePestsModal">
    <PestsModalContent :tab="pests" />
  </ModalView>
</template>

<script setup>
import { inject, ref, watch } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay } from 'swiper/modules'
import { useMeta } from 'vue-meta'
import { useScroll, useModal, useTab, useSlide } from '@/hooks'
import ModalView from '@/components/common/ModalView.vue'
import FlyModalContent from '@/components/modal/FlyModalContent.vue'
import PestsModalContent from '@/components/modal/PestsModalContent.vue'

const { sectionRef, checkSectionRef, buttonRef, buttonClass, buttonHiddenClass } = useScroll()
const { prevDisabled, nextDisabled, swiperRef, onSlideChange, slidePrev, slideNext } = useSlide()
const { modalState, openModal, closeModal } = useModal()
const { tab, handleTabClick } = useTab(openModal)

const mobileCheck = inject('mobileCheck')

const tabList = [
  { id: 0, name: 'Outermost Perimeter Defense' },
  { id: 1, name: 'Perimeter Defense' },
  { id: 2, name: 'Indoor Defense' },
  { id: 3, name: 'Mylab Self-Care' }
]

// entrance swiper
const entranceSwiperRef = ref(null)
const entrancePrevDisabled = ref(true)
const entranceNextDisabled = ref(false)

const onEntranceSlideChange = e => {
  const isBeginning = e.isBeginning
  const isEnd = e.isEnd

  if (isBeginning) entrancePrevDisabled.value = true
  else entrancePrevDisabled.value = false

  if (isEnd) entranceNextDisabled.value = true
  else entranceNextDisabled.value = false
}

const entranceSlidePrev = () => {
  entranceSwiperRef.value.$el.swiper.slidePrev()
}

const entranceSlideNext = () => {
  entranceSwiperRef.value.$el.swiper.slideNext()
}

// pests modal
const pests = ref(0)
const pestsModalState = ref(false)

const openPestsModal = () => {
  pestsModalState.value = true
}

const closePestsModal = () => {
  pestsModalState.value = false
}

const handlePestsClick = index => {
  if (!mobileCheck.value) return

  pests.value = index
  openPestsModal()
}

watch(pestsModalState, value => {
  value ? (document.body.style.overflow = 'hidden') : document.body.style.removeProperty('overflow')
})

useMeta({
  title: 'CESCO - Flying Insect Control Solution (FIC Solution)',
  meta: [
    {
      vmid: 'description',
      name: 'description',
      content: "'CESCO's Unique Approach to Blocking Flying Insects"
    }
  ]
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/fly.scss';
</style>
